<template>
  <div>
    <md-table v-if="!!tableData.length" md-card @md-selected="onSelect" class="table-hover">
      <md-table-toolbar>
        <div class="md-toolbar-section-start md-layout-item md-size-50">
          <h1 class="md-title">{{ title }}</h1>
        </div>

        <div class="md-toolbar-section-end md-layout-item md-size-33 ml-auto">
          <md-field md-clearable class="md-toolbar-section-start md-layout-item">
            <md-input placeholder="Buscar por nombre" v-model="search" @input="searchOnTable" />
          </md-field>
          <div class="ml-auto">
            <slot name="title-actions"></slot>
          </div>
        </div>
      </md-table-toolbar>

      <md-table-toolbar slot="md-table-alternate-header" slot-scope="{ count }">
        <div class="md-toolbar-section-start">{{ getAlternateLabel(count) }}</div>
      </md-table-toolbar>

      <md-table-row>
        <md-table-head>
          <md-button class="md-round md-just-icon md-info" @click="expandAll">
            <md-icon>expand_more</md-icon>
            <!-- <md-icon>
              {{
              !visibleRequisitions[item.id] ? "expand_more" : "expand_less"
              }}
            </md-icon>-->
            <md-tooltip md-direction="right">Ver requisiciones asociadas</md-tooltip>
          </md-button>
        </md-table-head>
        <md-table-head>Código</md-table-head>
        <md-table-head>Nombre</md-table-head>
        <md-table-head>Cantidad</md-table-head>
        <md-table-head>Unidad de medida</md-table-head>
        <md-table-head>Autopista</md-table-head>
        <md-table-head>Familia de insumo</md-table-head>
        <md-table-head>Precio</md-table-head>
        <md-table-head>Requisición</md-table-head>
        <md-table-head>Seleccionar</md-table-head>
      </md-table-row>

      <template v-for="item in searched">
        <md-table-row :key="item.id">
          <md-table-cell>
            <md-button
              class="md-round md-just-icon md-info"
              @click="
                visibleRequisitions[item.id] = !visibleRequisitions[item.id]
              "
            >
              <md-icon>
                {{
                !visibleRequisitions[item.id] ? "expand_more" : "expand_less"
                }}
              </md-icon>
              <md-tooltip md-direction="right">Ver requisiciones asociadas</md-tooltip>
            </md-button>
          </md-table-cell>
          <md-table-cell md-label="Código">{{ item.supplyCode }}</md-table-cell>
          <md-table-cell md-label="Nombre">{{ item.supplyName }}</md-table-cell>
          <md-table-cell md-label="Cantidad">{{ item.quantity }}</md-table-cell>
          <md-table-cell md-label="Unidad de medida">{{ item.supplyUnitMeasurement }}</md-table-cell>
          <md-table-cell md-label="Autopista">{{ item.highway }}</md-table-cell>
          <md-table-cell md-label="Familia de insumo">{{ item.supplyFamily }}</md-table-cell>
          <md-table-cell md-label="Precio">
            <div class="outlined-field-dense">
              <md-field>
                <md-input v-model="item.supplyPrice" type="number" step="0.000001"></md-input>
              </md-field>
            </div>
          </md-table-cell>
          <md-table-cell md-label="Requisición">{{ item.sinRequisitionNumber }}</md-table-cell>

          <md-table-cell md-label="Seleccionar">
            <md-checkbox style="margin: 0" v-model="selected" :value="item"></md-checkbox>
          </md-table-cell>

          <md-table-cell v-if="hasActions" md-label="Acciones">
            <md-button
              v-for="action in actions"
              :key="action.icon"
              class="md-just-icon md-success md-size-2x"
              @click.native="action.exe(item)"
            >
              <md-icon>{{ action.icon }}</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>

        <md-table-row v-if="visibleRequisitions[item.id]">
          <md-table-cell class="requisition-cell" colspan="10">
            <h6>
              <strong>Requisiciones</strong>
            </h6>
            <md-table md-card v-model="item.requisitions">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Folio">{{ item.folio }}</md-table-cell>
                <md-table-cell md-label="Autopista">{{ item.highway.name }}</md-table-cell>
                <md-table-cell md-label="Solicitante">{{ item.applicant.name }}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-table-cell>
        </md-table-row>
      </template>
    </md-table>
    <md-empty-state v-else md-icon="category" md-label="No hay insumos" md-rounded></md-empty-state>
  </div>
</template>

<script>
const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term)
    return items.filter((item) =>
      toLower(item.supplyName).includes(toLower(term))
    );
  return items;
};

export default {
  name: "TableActions",
  props: {
    title: String,
    tableHeaders: Object,
    actions: Array,
    hasActions: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    search: "",
    selected: [],
    searched: [],
    visibleRequisitions: null,
  }),
  computed: {
    total() {
      return this.tableData.length > 0
        ? this.tableData.length
        : this.tableData.length;
    },
  },
  methods: {
    onSelect(items) {
      this.selected = items;
    },
    getAlternateLabel(count) {
      let plural = "requisición",
        plural1 = "";

      if (count > 1) {
        plural = "requisiciones";
        plural1 = "s";
      }

      return `${count} ${plural} seleccionada${plural1}`;
    },
    searchOnTable() {
      this.searched = searchByName(this.tableData, this.search);
    },
    expandAll() {
      for (let key in this.visibleRequisitions) {
        this.visibleRequisitions[key] = true;
      }
    },
  },
  watch: {
    selected() {
      this.$emit("selected", this.selected);
    },
    tableData() {
      this.searched = this.tableData;
      this.selected = [];
    },
    searched(value) {
      const visibleRequisitions = {};
      for (const item of value) {
        visibleRequisitions[item.id] = false;
      }

      this.visibleRequisitions = visibleRequisitions;
    },
  },
};
</script>

<style lang="less" scoped>
.requisition-cell {
  background-color: rgb(252, 246, 242);
  padding: 0 15px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/QuatationsSupplies/TableActions.vue